module.exports = __webpack_public_path__ + "fonts/Rubik-400-arabic13.34f14a7.woff2";